import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.login');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-admin-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.login/view.scss */
@import '/assets/font/SUIT/SUIT.css';
:host {
  display: block;
  height: 100%;
  width: 100%;
}

.admin-login {
  position: relative;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: "SUIT", sans-serif;
  background: radial-gradient(circle at top, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0) 34%), linear-gradient(180deg, #f5f5f7 0%, #eef1f5 100%);
}

.admin-login::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0));
  pointer-events: none;
}

.admin-login__card {
  animation: admin-login-card-enter 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
  position: relative;
  z-index: 1;
  width: min(100%, 392px);
  padding: 38px 32px 30px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 60px -34px rgba(15, 23, 42, 0.22), 0 2px 8px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(28px);
}

@keyframes admin-login-card-enter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .admin-login *,
  .admin-login *::before,
  .admin-login *::after {
    animation-duration: 0.01ms !important;
    animation-delay: 0ms !important;
    transition-duration: 0.01ms !important;
  }
}
.admin-login__brand-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.admin-login__logo {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.admin-login__title {
  margin: 20px 0 0;
  color: #0f172a;
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -0.06em;
  line-height: 1;
}

.admin-login__form {
  margin-top: 28px;
  display: grid;
  gap: 12px;
}

.admin-login__field {
  display: block;
}

.admin-login__input-wrap {
  position: relative;
}

.admin-login__input-icon {
  position: absolute;
  top: 50%;
  left: 18px;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 14px;
  pointer-events: none;
}

.admin-login__input {
  width: 100%;
  height: 56px;
  padding: 0 18px 0 48px;
  border: 1px solid rgba(209, 213, 219, 0.92);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  color: #0f172a;
  font-size: 14px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.admin-login__input::placeholder {
  color: #9ca3af;
}

.admin-login__input:focus {
  outline: none;
  border-color: rgba(15, 23, 42, 0.24);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
}

.admin-login__error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(254, 205, 211, 0.92);
  background: rgba(255, 241, 242, 0.9);
  color: #be123c;
  font-size: 12px;
  line-height: 1.55;
}

.admin-login__submit {
  position: relative;
  width: 100%;
  height: 56px;
  border: 0;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;
  color: #f8fafc;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.02em;
  cursor: pointer;
  background: linear-gradient(180deg, #1f2937 0%, #111827 100%);
  box-shadow: 0 18px 32px -24px rgba(15, 23, 42, 0.34);
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.admin-login__submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 20px 36px -24px rgba(15, 23, 42, 0.38);
}

.admin-login__submit:disabled {
  cursor: default;
  opacity: 0.7;
}

.admin-login__submit.is-loading {
  background: linear-gradient(135deg, #334155 0%, #0f172a 100%);
}

.admin-login__submit-glow {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0));
  pointer-events: none;
}

.admin-login__submit > * {
  position: relative;
  z-index: 1;
}

@media (max-width: 1100px) {
  .admin-login {
    padding: 18px;
  }
}
@media (max-width: 720px) {
  .admin-login {
    padding: 12px;
  }
  .admin-login__brand-mark {
    width: 52px;
    height: 52px;
    padding: 10px;
    border-radius: 16px;
  }
  .admin-login__title {
    margin-top: 18px;
    font-size: 34px;
  }
  .admin-login__card {
    width: 100%;
    padding: 32px 20px 24px;
    border-radius: 24px;
  }
  .admin-login__input,
  .admin-login__submit {
    height: 54px;
  }
}`],
})
export class PageAdminLoginComponent implements OnInit {
    public email: string = '';
    public password: string = '';
    public loading: boolean = false;
    public error: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        const me = await this.service.me();
        if (me) {
            this.service.href('/admin/dashboard');
            return;
        }
    }

    public async submit() {
        if (this.loading) {
            return;
        }
        if (!this.email || !this.password) {
            this.error = '이메일과 비밀번호를 입력해 주세요.';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        await this.service.render();
        const res = await this.service.login(this.email, this.password);
        this.loading = false;
        await this.service.render();
        if (res.ok) {
            this.service.href('/admin/dashboard');
        } else {
            this.error = res.message || '로그인에 실패했습니다.';
            await this.service.render();
        }
    }

    public async onKey(e: KeyboardEvent) {
        if (e.key !== 'Enter') {
            return;
        }
        e.preventDefault();
        await this.submit();
    }
}

export default PageAdminLoginComponent;